import { styled } from "@material-ui/core";
import React from "react";
import PackageLogoSvg from "./PackageLogoSvg";
import Imgix from "react-imgix";

const HEADER_HEIGHT_DESKTOP = "30px";
const HEADER_HEIGHT_MOBILE = "16px";

const PADDING_DESKTOP = "6px";
const PADDING_MOBILE = "4px";

export const PodImageWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  background: theme.palette.primary.main,
  // 1:1 Aspect ratio
  paddingBottom: "100%",
  height: 0,
  position: "relative",
  overflow: "hidden"
}));

export const PackageLogo = styled("div")(({ theme }) => ({
  // Top center
  position: "absolute",
  top: "10px",
  left: "50%",
  transform: "translateX(-50%)",
  height: "auto",
  [theme.breakpoints.down("xs")]: {
    top: "0px",
    height: HEADER_HEIGHT_MOBILE
  },
  "& > svg": {
    width: "auto",
    height: "12px",
    [theme.breakpoints.down("xs")]: {
      height: "7px"
    }
  }
}));

export const ImageMask = styled("div")(({ theme }) => ({
  position: "absolute",
  overflow: "hidden",
  bottom: PADDING_DESKTOP,
  left: PADDING_DESKTOP,
  width: `calc(100% - ${PADDING_DESKTOP} * 2)`,
  height: `calc(100% - ${HEADER_HEIGHT_DESKTOP} - ${PADDING_DESKTOP} * 2)`,
  borderRadius: "3px",
  background: theme.palette.grey[100],
  [theme.breakpoints.down("xs")]: {
    bottom: PADDING_MOBILE,
    left: PADDING_MOBILE,
    width: `calc(100% - ${PADDING_MOBILE} * 2)`,
    height: `calc(100% - ${HEADER_HEIGHT_MOBILE} - ${PADDING_MOBILE} * 2)`,
    borderRadius: "2px"
  }
}));

export const CustomImgix = styled(Imgix)(({ theme }) => ({
  width: "100%",
  height: "auto",
  userSelect: "none",
  background: "transparent",
  // Move a bit up to center the image inside the ImageMask
  position: "absolute",
  top: "-12px",
  [theme.breakpoints.down("xs")]: {
    top: "-6px"
  }
}));

type Props = {
  artwork: {
    url: string;
    maxWidth: number;
  };
  onClick?: () => void;
};

const PodPackageImage = React.forwardRef<HTMLDivElement, Props>(
  ({ artwork: artwork, onClick }, ref) => {
    return (
      <PodImageWrapper
        ref={ref}
        onClick={onClick}
        className="pod-package-image"
      >
        <PackageLogo>
          <PackageLogoSvg />
        </PackageLogo>
        <ImageMask>
          <CustomImgix
            src={artwork.url}
            width={artwork.maxWidth}
            height={artwork.maxWidth}
            imgixParams={{
              ar: "1",
              fit: "crop",
              auto: "format,compress"
            }}
            htmlAttributes={{
              draggable: false,
              loading: "lazy"
            }}
          />
        </ImageMask>
      </PodImageWrapper>
    );
  }
);

export default React.memo(PodPackageImage);
